import { useQuery } from '@tanstack/react-query';
import { billingService, Subscription, PaymentMethod, Invoice } from '@/services/billingService';

export const useBilling = () => {
  const {
    data: subscription,
    isLoading: isSubscriptionLoading,
    error: subscriptionError,
  } = useQuery<Subscription>({
    queryKey: ['subscription'],
    queryFn: async () => {
      console.log('Fetching subscription...');
      try {
        const result = await billingService.getSubscription();
        console.log('Subscription result:', result);
        return result;
      } catch (error) {
        console.error('Subscription error:', error);
        throw error;
      }
    },
    enabled: true, // Enable by default to load subscription data
  });

  const {
    data: paymentMethod,
    isLoading: isPaymentMethodLoading,
    error: paymentMethodError,
  } = useQuery<PaymentMethod>({
    queryKey: ['paymentMethod'],
    queryFn: async () => {
      console.log('Fetching payment method...');
      try {
        const result = await billingService.getPaymentMethod();
        console.log('Payment method result:', result);
        return result;
      } catch (error) {
        console.error('Payment method error:', error);
        throw error;
      }
    },
    enabled: true, // Enable by default to load payment method data
  });

  const {
    data: invoices,
    isLoading: isInvoicesLoading,
    error: invoicesError,
  } = useQuery<Invoice[]>({
    queryKey: ['invoices'],
    queryFn: async () => {
      console.log('Fetching invoices...');
      try {
        const result = await billingService.getInvoices();
        console.log('Invoices result:', result);
        return result;
      } catch (error) {
        console.error('Invoices error:', error);
        throw error;
      }
    },
    enabled: true, // Enable by default to load invoices data
  });

  const isLoading = isSubscriptionLoading || isPaymentMethodLoading || isInvoicesLoading;
  const error = subscriptionError || paymentMethodError || invoicesError;

  // Debug logging
  if (error) {
    console.error('useBilling error:', {
      subscriptionError: subscriptionError?.message,
      paymentMethodError: paymentMethodError?.message,
      invoicesError: invoicesError?.message,
      combinedError: error?.message
    });
  }

  return {
    subscription,
    paymentMethod,
    invoices,
    isLoading,
    error,
  };
}; 